!function() {
  "use strict";
  customElements.get("site-header") || customElements.define("site-header", class extends HTMLElement {
    constructor() {
      super(), this.toggle = this.querySelector("details"), this.level1Details = this.querySelectorAll("details.header--level1"), 
      this.level1Toggles = this.querySelectorAll("details.header--level1 summary.header--level1"), 
      this.level2Menus = this.querySelectorAll(".header__level2"), this.timeout = null, 
      this.index = null, this.delay = 100, this.observer = null, this.tabletMQ = null, 
      this.desktopMQ = null, this.handleToggle = this.handleToggle.bind(this), this.handleToggleLevel0 = this.handleToggleLevel0.bind(this), 
      this.handleToggleME = this.handleToggleME.bind(this), this.handleToggleML = this.handleToggleML.bind(this), 
      this.handleMenuME = this.handleMenuME.bind(this), this.handleMenuML = this.handleMenuML.bind(this), 
      this.closeMenu = this.closeMenu.bind(this), this.toggle.addEventListener("toggle", this.handleToggleLevel0), 
      this.init();
    }
    handleToggleLevel0(e) {
      if ("open" === e.newState && this.tabletMQ.matches) {
        const e = document.querySelector("header-search details");
        e && (e.removeAttribute("open"), e.dispatchEvent(new Event("toggle")));
      }
    }
    handleToggle(e) {
      if ("open" === e.newState) {
        if (document.body.classList.add("overflow-clip"), this.classList.add("menu-open"), 
        this.desktopMQ.matches) {
          const e = document.querySelector("header-search details");
          e && (e.removeAttribute("open"), e.dispatchEvent(new Event("toggle")));
        }
      } else document.body.classList.remove("overflow-clip"), this.classList.remove("menu-open");
    }
    handleToggleME(e) {
      clearTimeout(this.timeout);
      const t = this.index;
      this.index = Array.from(this.level1Toggles).indexOf(e.target), this.index !== t && (this.querySelector("details.header--level1[open]")?.removeAttribute("open"), 
      e.target.click());
    }
    handleToggleML(e) {
      this.timeout = setTimeout(this.closeMenu, this.delay);
    }
    handleMenuME() {
      clearTimeout(this.timeout);
    }
    handleMenuML() {
      this.timeout = setTimeout(this.closeMenu, this.delay);
    }
    closeMenu() {
      this.level1Toggles[this.index]?.parentElement.hasAttribute("open") && (this.level1Toggles[this.index].click(), 
      this.index = null);
    }
    addEventListeners() {
      for (const e of this.level1Toggles) e.addEventListener("mouseenter", this.handleToggleME, {
        passive: !0
      }), e.addEventListener("mouseleave", this.handleToggleML, {
        passive: !0
      });
      for (const e of this.level2Menus) e.addEventListener("mouseenter", this.handleMenuME, {
        passive: !0
      }), e.addEventListener("mouseleave", this.handleMenuML, {
        passive: !0
      });
      for (const e of this.level1Details) e.addEventListener("toggle", this.handleToggle);
    }
    removeEventListeners() {
      for (const e of this.level1Toggles) e.removeEventListener("mouseenter", this.handleToggleME, {
        passive: !0
      }), e.removeEventListener("mouseleave", this.handleToggleML, {
        passive: !0
      });
      for (const e of this.level2Menus) e.removeEventListener("mouseenter", this.handleMenuME, {
        passive: !0
      }), e.removeEventListener("mouseleave", this.handleMenuML, {
        passive: !0
      });
      for (const e of this.level1Details) e.removeEventListener("toggle", this.handleToggle);
    }
    desktopChanges() {
      let e = 0, t = null;
      if (this.desktopMQ.matches) {
        for (const s of document.querySelectorAll(".header__level2")) {
          s.parentElement.setAttribute("open", "");
          const i = s.getBoundingClientRect().width;
          i > e && (e = i, t = s);
        }
        this.style.setProperty("--level-2-width", `${e}px`);
      }
      for (const e of document.querySelectorAll(".header__level2")) e.id !== t?.id && this.desktopMQ.matches && e.querySelector("ul").classList.add("megamenu--small"), 
      e.parentElement.removeAttribute("open"), e.classList.remove("js:invisible");
    }
    tabletChanges(e) {
      if (this.tabletMQ.matches) {
        e.removeAttribute("open");
        const t = document.querySelectorAll("details:not(.header--level0)");
        for (const e of t) e.removeAttribute("open");
      } else e.setAttribute("open", "");
    }
    init() {
      const e = window.matchMedia("(hover: none)");
      e.matches || this.addEventListeners(), e.addEventListener("change", (e => {
        e.matches ? this.removeEventListeners() : this.addEventListeners();
      })), this.desktopMQ = window.matchMedia("(min-width: 1024px)"), this.desktopChanges(), 
      this.desktopMQ.addEventListener("change", (e => {
        this.desktopMQ = e, this.desktopChanges();
      })), this.tabletMQ = window.matchMedia("(max-width: 1024px)");
      const t = document.querySelector("details.header--level0");
      this.tabletChanges(t), t.classList.remove("js:opacity-0"), this.tabletMQ.addEventListener("change", (e => {
        this.tabletMQ = e, this.tabletChanges(t);
      }));
    }
  });
}();